import { useEffect, useState } from "react";
import { getPairTicker } from "../../Quotes/pairMeta";
import { assetSettingsService } from "./assetSettingsService";

/**
 * Max profit and market impact settings of the pair's asset.
 *
 * @param {string} [pairSlug] e.g. "BTCUSDT"
 * @returns {{ settings: object|null, loading: boolean }} settings of
 *   assetSettingsService.getAssetSettings, null until loaded
 */
export const useAssetSettings = (pairSlug) => {
  const [settings, setSettings] = useState(null);
  const ticker = getPairTicker(pairSlug);

  useEffect(() => {
    if (!ticker) return undefined;

    let isActual = true;

    setSettings(null);
    assetSettingsService.getAssetSettings(ticker).then((result) => {
      if (isActual) setSettings(result);
    });

    return () => {
      isActual = false;
    };
  }, [ticker]);

  return { settings, loading: Boolean(ticker) && !settings };
};
